import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { AppService } from '../../services/services';
import { Router } from "@angular/router";
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import {IMyDefaultMonth, INgxMyDpOptions } from '@mksasi/ngx-mydatepicker';
import { enc, SHA512 } from 'crypto-js';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from "src/app/services/encryption.service";
import { Modal } from "bootstrap";
import { ErrorModalComponent } from "src/app/common/error-modal/error-modal.component";

@Component({
    selector: 'app-foreign-address',
    templateUrl: './foreign-address.component.html',
    styleUrls: ['./foreign-address.component.scss']
})

export class ForeignAddressComponent implements OnInit{
    @ViewChild('foAdrimg') foAdrimgError: ElementRef;
    addressForm = this.formBuilder.group({
      'AddressLine1': ['', [Validators.required, Validators.minLength(3), this.noWhitespaceValidator]],
      'AddressLine2': ['', [Validators.required, Validators.minLength(3), this.noWhitespaceValidator]],
      'AddressLine3': ['', [Validators.required, Validators.minLength(3), this.noWhitespaceValidator]],
      'City': ['',Validators.required],
      'Country': ['',Validators.required],
      'CommunicationAddress': [false, Validators.required],
      'DocType': ['',Validators.required],
      'PinCode': ['',Validators.required],
      'State': ['',Validators.required],
      // 'DocNumber': ['',Validators.required],
    });
    countryList: any;
    countryName: string = '';
    docTypeList: any = '';
    docError: boolean = false;
    erefNo: string = '';
    foAdrImgempty:boolean = false;
    foAdrImgemptyBack:boolean = false;
    foAdrUpdt:boolean = false;
    foAdrUpdtBack:boolean = false;
    previousDocs: boolean = false;
    docName: string = '';
    reStatus: any;
    marineStatus: string;
    getStatusData: any;
    changeIDs:string | number;
    passCountry:boolean = false;
    StageSkip: string = '';
    poioci: string = '';
     options2:INgxMyDpOptions = {
          dateFormat: 'dd/mm/yyyy',
        };
          defaultMonth: IMyDefaultMonth;
          lastArrivalDt: any;
          arrivalDateError: boolean = false;
          lastArrivalDate: any = '';
          expiryDateError: boolean = false;
          prevsixMonthDate:any;
        sixMonthDate:any;
        ExpiryDate: any;
      datesection =false;
      PValidation: string = '';
      docNumber :any;
      ProofName: string = '';
      AddrProofNum :boolean = true;

    @ViewChild('errorComp') errorComp : ErrorModalComponent;
  constructor(private loader: NgxUiLoaderService,private toastr:ToastrService,private http:EncryptionService,  public _http: AppService, private router: Router,public formBuilder: FormBuilder){
        this._http.getRefNum().subscribe(data=>{
            this.erefNo = data;
        });
        this._http.getStatus().subscribe((data:any)=>{
          this.getStatusData = data;
        })
  }
  // ngOnInit() {
  //       this._http.getMasters().subscribe(data=>{
  //           if(data && data.OccupationList){
  //               this.docTypeList  = data.DocumentTypeList;
  //               this.docTypeList = data.DocumentTypeList.filter((e:any)=>{
  //               return e.DocumentCategory === 1;
  //               })
  //           }
  //       });
  //       this._http.getStatus().subscribe(data=>{
  //         if(data.ReStatus === 'FN'){
  //           this.reStatus = data.ReStatus;
  //         }else{
  //           this.reStatus = data.ReStatus;
  //         }
  //       })
  //       this.countryList = this._http.countryList.filter((e:any)=>{
  //         return e.Name !== 'India';
  //       });
  //       this.getAddressInfo();
  //   }
  ngOnInit() {
    this._http.scroll();
    this._http.getMasters().subscribe(data=>{
        if(data && data.OccupationList){
            this.docTypeList  = data.DocumentTypeList;
            this._http.getStatus().subscribe(d=>{
     
                this.docTypeList = data.DocumentTypeList.filter((e:any)=>{
                  
                  return e.DocumentCategory === 1;
                })
              
              if(d.ReStatus === 'FN'){
                this.reStatus = d.ReStatus;
              }else{
                this.reStatus = d.ReStatus;
              }
            })
        }
    });
    this._http.getStatus().subscribe(d => {
      if (d.PIOOCIType === 'P') {
        this.docTypeList = this.docTypeList.filter((d: any) => d.DocumentTypeId !== 2); // Remove OCI Card
      } else if (d.PIOOCIType === 'O') {
        this.docTypeList = this.docTypeList.filter((d: any) => d.DocumentTypeId !== 3); // Remove PIO Card
      }else if (d.PIOOCIType === 'F') {
        this.docTypeList = this.docTypeList.filter((d: any) => d.DocumentTypeId !== 1); // Remove passport 
      }
    })
     const today = new Date();
    const disableDate = new Date();
    disableDate.setDate(today.getDate() + 60);
    this.options2 = {
      dateFormat: 'dd/mm/yyyy',
      showTodayBtn: false,
      disableUntil: { 
        year: disableDate.getFullYear(), 
        month: disableDate.getMonth() + 1, 
        day: disableDate.getDate()  
      }
    }
    this.defaultMonth = {
      defMonth: `${disableDate.getMonth() + 1}/${disableDate.getFullYear()}`
    };
    let month:any = this.defaultMonth.defMonth.split('/');
    if (Number(month[0]) < 10) {
      month = '0' + month[0];
    }
    this.defaultMonth.defMonth = `${month}/${disableDate.getFullYear()}`;
    this.countryList = this._http.countryList.filter((e:any)=>{
      return e.Name !== 'India';
    });
    this.getAddressInfo();
    this.overallStatus();
  }
overallStatus(){
  let url = 'DIY/DIYOverallStatus';
  this.loader.start();
  let checkSum = this.erefNo;    
  let params = {
    'ReferenceNumber': this.erefNo,
  }
  this._http.httpPost(url,params, checkSum).subscribe({
    next: (data:any) => {
      this.loader.stop();
      let val=this.http.decryptUsingAES256(data.OutPut)
      if(val && val.IsSuccess){
        let item = val.overallLists;
        this.StageSkip = item[3].StageSkip;
      }
        if (val.PIOOCIType === 'P') {
        this.docTypeList = this.docTypeList.filter((d: any) => d.DocumentTypeId !== 2); // Remove OCI Card
      } else if (val.PIOOCIType === 'O') {
        this.docTypeList = this.docTypeList.filter((d: any) => d.DocumentTypeId !== 3); // Remove PIO Card
      }else if (val.PIOOCIType === 'F') {
        this.docTypeList = this.docTypeList.filter((d: any) => d.DocumentTypeId !== 1); // Remove passport 
      }

    },
    error: _error=>{
      this.loader.stop();
      // this.toastr.error(_error.error.Message)
      this.errorComp.ModalShow(_error.error.Message);
    }
  })
}



    public noWhitespaceValidator(control: FormControl) {
        return (control.value || '').trim().length? null : { 'whitespace': true };       
    }

    getAddressInfo(){
        let url = "DIY/DIYGetForeAddr";
        let checkSum = this.erefNo;
        let params = {
          "ReferenceNumber": this.erefNo
        }
        this.loader.start();
        this._http.httpPost(url, params, checkSum).subscribe({
          next: (data:any)=>{
            this.loader.stop();
            let val=this.http.decryptUsingAES256(data.OutPut)
            if(val && val.IsSuccess){
              this.poioci=val.PIO_OCI
              if(this.poioci==='OCI'){
                this.poioci ='OCI Card'
              }else if(this.poioci==='PIO'){
                this.poioci ='PIO Card'
              }
              this.addressForm.patchValue({
                'AddressLine1': val.AddressLine1,
                'AddressLine2': val.AddressLine2,
                'AddressLine3': val.AddressLine3,
                'City': val.City,
                'CommunicationAddress': val.CommunicationAddress,
                'State': val.State,
                'PinCode': val.Pincode,
                'Country': val.Country,
                'DocType': val.DocumentId,
                // 'DocNumber' : val.COR_ADD_REF
             });
             if(val.COR_ADD_REF){
              this.docNumber = val.COR_ADD_REF;
             }

             if(val.DocumentId === 1||val.DocumentId === 5||val.DocumentId === 4||val.DocumentId === 6||val.DocumentId === 1034||val.DocumentId === 1038){

            this.datesection = true;
           }
          //   if(val.DocumentId  === 1||val.DocumentId  === 2||val.DocumentId  === 3||val.DocumentId  === 4||val.DocumentId  === 5||val.DocumentId  === 6||val.DocumentId === 1037){
          //   this.AddrProofNum = true;
          // }else{
          //   this.AddrProofNum = false;
          // }
             if(val.PassportNationality){
                this.passCountry = true;
             }
             if(val.ExpiryDate){
            let a = val.ExpiryDate.split(' ');
            let d = a[0].split('/'); 
            this.lastArrivalDate = a[0];
            this.lastArrivalDt = { date: { year: d[2], month: parseInt(d[1]), day: parseInt(d[0]) } };
          }
          // if(val.DocumentId  === 7||val.DocumentId  === 8||val.DocumentId  === 1034||val.DocumentId  === 1035||val.DocumentId  === 1036){
          //   this.PValidation = 'Y'
          // }else{
          //   this.PValidation = 'N'
          // }
           if(val.DocumentId  === 1||val.DocumentId  === 2||val.DocumentId  === 3||val.DocumentId  === 4||val.DocumentId  === 5||val.DocumentId  === 6){
            this.PValidation = 'N';
          }else{
            this.PValidation = 'Y';
          }
          
             this.docTypeCheck(val.DocumentId,false);
            }
           
          },error: _error=>{
            this.loader.stop();
            // this.toastr.error(_error.error.Message);
            this.errorComp.ModalShow(_error.error.Message);
          }
        })
    }
    
    // onInputChange(event:any){
    //     const pattern = new RegExp('^[a-zA-Z0-9.,/ \b]+$');
    //     const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    //     if (!pattern.test(key) && event.charCode !== 0) {
    //       event.preventDefault();
    //       return;
    //     }
    // }

    onInputChanged(event: Event) {
      const inputElement = event.target as HTMLInputElement;
      const currentValue = inputElement.value;
      const allowedCharacters = /^[a-zA-Z0-9.,/\s]+$/;
    
      // Remove disallowed characters from the input value
      const sanitizedValue = currentValue.split('').filter(char => allowedCharacters.test(char)).join('');
    
      // Set the sanitized value back to the input field
      inputElement.value = sanitizedValue;
    }

    onlyNumberKey(event: any) {
      const pattern = new RegExp('^[0-9\b]+$');
      const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!pattern.test(key) && event.charCode !== 0) {
        event.preventDefault();
        return;
      }
    }

    // alphabetOnly(event:any){
    //     const pattern = new RegExp('^[a-zA-Z \b]+$');
    //     const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    //     if (!pattern.test(key) && event.charCode !== 0) {
    //       event.preventDefault();
    //       return;
    //     }
    // }

    onInputChange(event: any) {
      const pattern = /^[a-zA-Z \b]+$/;
      const inputText = event.target.value;
    
      if (!pattern.test(inputText)) {
        // Remove invalid characters from the input value
        event.target.value = inputText.replace(new RegExp(`[^a-zA-Z \b]+`, 'g'), '');
      }
    }

    alphaNumeric(event: any) {
      const inputText = event.target.value;
      const sanitizedText = inputText.replace(/[^a-zA-Z0-9]/g, '');

      if (inputText !== sanitizedText) {
        event.target.value = sanitizedText;
      }
    }
    

    // alphabetNumericOnly(event:any){
    //     const pattern = new RegExp('^[a-zA-Z0-9 \b]+$');
    //     const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    //     if (!pattern.test(key) && event.charCode !== 0) {
    //       event.preventDefault();
    //       return;
    //     }
    // }
      
    spaceValidation(event:any, name: string){
        const input = event.target.value;
        event.target.value = input.replace(/^\s+|\s+$|\s+(?=\s)/g, "");
        if(name === 'AddressLine1' || name === 'AddressLine2' || name === 'AddressLine3' || name === 'City' || name === 'State' || name === 'PinCode'){
            this.addressForm.controls[name].setValue(event.target.value);
        }
    }

    getCountryName(){
        let a:any = this.addressForm.controls.Country.value;
        let c = parseInt(a);
        let name = this.countryList.filter((e:any)=>{
          return e.Id === c;
        })
        this.countryName = name[0].Name;
      }

    typeError(event: boolean){
        this.docError = event;
    }

    getID(id: any){
        this.addressForm.controls.DocType.setValue(id);
    }

    imageURL(event: any){
      if(event.url && event.name === "ForeignAddr"){
        this.foAdrUpdt = true;
        this.foAdrImgempty = false;
      }
      if(event.url && event.name === "ForeignAddrBack"){
        this.foAdrImgemptyBack = false;
        this.foAdrUpdtBack = true;
      }
      if(!event.url && event.name === 'ForeignAddr'){
        this.foAdrUpdt = false;
      }
      if(!event.url && event.name === 'ForeignAddrBack'){
        this.foAdrUpdtBack = false;
      }
    }

    checkType(event: any){
      this.docTypeCheck(event.target.value,true);
      if((event.target.value === 2 || event.target.value === "2") || (event.target.value === 3 || event.target.value === "3")){
        this._http.setPio({
          PIOOCI:true,
        })
      }else{
        this._http.setPio({
          PIOOCI:false,
        })
      }
      
    }

    docTypeCheck(e:any,get:boolean){
      this.datesection = false;
        let b = parseInt(e);
        let a = this.docTypeList.filter((e:any)=>{
          return e.DocumentTypeId === b;
        })
        if(a.length >=1){
          if(a[0].DocumentTypeId === 1||a[0].DocumentTypeId === 5||a[0].DocumentTypeId === 4||a[0].DocumentTypeId === 6||a[0].DocumentTypeId === 1034||a[0].DocumentTypeId === 1038){
            this.datesection = true;
          }
          // if(a[0].DocumentTypeId  === 7||a[0].DocumentTypeId  === 8||a[0].DocumentTypeId  === 1034||a[0].DocumentTypeId  === 1035||a[0].DocumentTypeId  === 1036){
          //   this.PValidation = 'Y'
          // }else{
          //   this.PValidation = 'N'
          // }
          if(a[0].DocumentTypeId  === 1||a[0].DocumentTypeId  === 2||a[0].DocumentTypeId  === 3||a[0].DocumentTypeId  === 4||a[0].DocumentTypeId  === 5||a[0].DocumentTypeId  === 6||a[0].DocumentTypeId === 1037){
            this.PValidation = 'N'
          }else{
            this.PValidation = 'Y'
          }
          this.ProofName =a[0].Name;
          // if(a[0].DocumentTypeId === 1||a[0].DocumentTypeId === 2||a[0].DocumentTypeId === 3||a[0].DocumentTypeId === 4||a[0].DocumentTypeId === 5||a[0].DocumentTypeId === 6||a[0].DocumentTypeId === 1037){
          //   this.AddrProofNum = true;
          // }else{
          //   this.AddrProofNum = false;
          // }
        if((a[0].Name === 'Passport' || (a[0].OCI && this.reStatus === 'FN')) && !this.passCountry){
          this.previousDocs = true;
          this.foAdrUpdt = true;
          this.foAdrImgempty = false;
          this.foAdrImgemptyBack = false;
          this.foAdrUpdtBack = true;
          if (get) this.getPassportInfo();
        }else if((a[0].Name === this.poioci )){
          this.previousDocs = true;
          this.foAdrUpdt = true;
          this.foAdrImgempty = false;
          this.foAdrImgemptyBack = false;
          this.foAdrUpdtBack = true;
          // if (get) this.getPassportInfo();
        }
        else if(a[0].Name === 'Passport' && this.passCountry &&this.StageSkip !=='F'){
          const element = document.getElementById('redirect') as HTMLElement;
          const theModal = new Modal(element, { backdrop: 'static', keyboard: false });
          theModal.show();
        }
        else{
          if(get){
            this.previousDocs = false;
            this.changeIDs = b;
          }
        }
      }
        if(a.length !== 0){
          this.docName = a[0].Name;
        }
    }
    goTo() {
      this.addressForm.controls.DocType.setValue("");
      // sessionStorage.clear();
      // location.reload();
    }


    getPassportInfo() {
      this.loader.start();
      const checksum = this.erefNo;
      const path = `DIY/DIYGetPassportOCR`;
      let params = {
        ReferenceNumber : this.erefNo
      }
      this._http.httpPost(path, params , checksum).subscribe({
        next : (data:any) => {
          this.loader.stop();
          let decryptData = this.http.decryptUsingAES256(data.OutPut);
          if(decryptData && decryptData.IsSuccess) {
            console.log(decryptData,"decrrrrrr");
            
            this.addressForm.patchValue({
              AddressLine1 : decryptData.AddressLine1 ? decryptData.AddressLine1 : '',
              AddressLine2 : decryptData.AddressLine2 ? decryptData.AddressLine2 : '',
              AddressLine3 : decryptData.AddressLine3 ? decryptData.AddressLine3 : '',
              State : decryptData.State ? decryptData.State : '',
              City : decryptData.City ? decryptData.City : '',
              PinCode : decryptData.Pincode ? decryptData.Pincode : '',
            })
          }
        }, 
        error : e => {
          this.loader.stop();
          this.errorComp.ModalShow(e.error.Message);
        }
      })
    }

    stageValidate(){
      let error = 0;
      
      
        if(!this.foAdrUpdt){
            this.foAdrImgempty = true;
            error ++
            // this.toastr.error('Please upload address proof front image');
            this.errorComp.ModalShow('Please upload address proof front image');
            return;
        }
        if(!this.docNumber && this.AddrProofNum){
            error ++;
            this.errorComp.ModalShow('Please Enter Address Proof Number.');
            return;
        }
        if(!this.foAdrUpdtBack){
          this.foAdrImgemptyBack = true;
          error++;
          // this.toastr.error('Please upload address proof back image');
          this.errorComp.ModalShow('Please upload address proof back image');
          return;
        }else if(!this.lastArrivalDate && this.datesection){
          this.errorComp.ModalShow('Please enter your Expiry Date');
            return;
          }
        // if(error >=1){
        //   this.toastr.error('Please upload address proof image');
        //   return;
        // }


        else if(this.addressForm.valid){
            let a:any = this.addressForm.controls.AddressLine1.value;
            let b:any = this.addressForm.controls.City.value;
            const checkSum = this.erefNo+a+b;
            this.loader.start();
            const params = {
                "ReferenceNumber": this.erefNo,
                "AddressLine1": this.addressForm.controls.AddressLine1.value,
                "AddressLine2": this.addressForm.controls.AddressLine2.value,
                "AddressLine3": this.addressForm.controls.AddressLine3.value,
                "City": this.addressForm.controls.City.value,
                'CommunicationAddress': this.addressForm.controls.CommunicationAddress.value,
                "State": this.addressForm.controls.State.value,
                "Pincode": this.addressForm.controls.PinCode.value,
                "Country": this.addressForm.controls.Country.value,
                "DocumentId": this.addressForm.controls.DocType.value,
                // "COR_ADD_REF" : this.addressForm.controls.DocNumber.value,
                "COR_ADD_REF" :this.docNumber,
                "ExDate": this.lastArrivalDate,
                "PValidation": this.PValidation,
            }
            
            let url = "DIY/DIYUpdtForeAddr";
            this._http.httpPost(url,params, checkSum).subscribe({
                next: (data:any)=>{
                this.loader.stop();
                let val=this.http.decryptUsingAES256(data.OutPut)
                if(val && val.IsSuccess){
                  // this.toastr.success(val.Success);
                  this.router.navigate(['/address'], { replaceUrl: true });
                }else{
                  // this.toastr.error("Please try again.");
                  this.errorComp.ModalShow("Please try again.");
                }
              },
              error: error=>{
                this.loader.stop();
                if(!window.navigator.onLine){
                  // this.toastr.error("It appears that your internet connectivity is slow or please try again.")
                  this.errorComp.ModalShow("It appears that your internet connectivity is slow or please try again.");
                }else{
                  // this.toastr.error(error.error.Message);
                  this.errorComp.ModalShow(error.error.Message);
                }
              }
            });
        }
    }

    backStage(){
      if(this.StageSkip==="F"){
        this.router.navigate(['/oci-pio'], { replaceUrl: true });
      }else{
        this.router.navigate(['/passport']);
      }
        
    }
    onDateChanged(event:any){
    this.lastArrivalDate = '';
    this.ExpiryDate = event.formatted;
    let e = this.ExpiryDate.split('/')
    let a = e[2]+'-'+e[1]+'-'+e[0];
    let d = new Date();
    let requiredDate= d.setDate(d.getDate() + 15);
    this.sixMonthDate = new Date(requiredDate);
    let selectedDate = new Date(a);
    if(this.sixMonthDate.getTime() > selectedDate.getTime())
    {
      this.expiryDateError = true;
    }else{
      this.expiryDateError = false;
    }
  }

  onDateArrival(event: any) {
    this.ExpiryDate = '';
    this.lastArrivalDate = event.formatted;
    
    // Convert the selected date to a proper Date object
    let e = this.lastArrivalDate.split('/');
    let formattedDate = `${e[2]}-${e[1]}-${e[0]}`;
    let selectedDate = new Date(formattedDate);

    // Get the current date and calculate the date 60 days ago
    let today = new Date();
    let sixtyDaysAgo = new Date(today.setDate(today.getDate() - 60));

    // Check if the selected date is more than 60 days before today
    if (selectedDate.getTime() < sixtyDaysAgo.getTime()) {
        this.arrivalDateError = true;
    } else {
        this.arrivalDateError = false;
    }
}
}